export default __webpack_public_path__ + "static/media/exclamation.41145c69.svg";